import {SidebarReducerType, TOGGLE_COLLAPSE} from '../actions/sidebar';

export interface SidebarReducerState {
    isCollapsed: boolean;
}

export const preloadedState = {
    isCollapsed: false,
};

export const sidebarReducer = (state: SidebarReducerState = preloadedState, action: SidebarReducerType): SidebarReducerState => {
    switch (action.type) {
        case TOGGLE_COLLAPSE:
            return {...state, isCollapsed: !state.isCollapsed};
        default:
            return state;
    }
};
